/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from "react";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  cartAction,
  profileAction,
  orderAction,
  shopAction,
} from "@redux/modules";

// Form Validations
import { Formik } from 'formik';
import * as yup from 'yup';

import Form from 'react-bootstrap/Form';

// Header - Footer
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';

// Toastify
import showMessage from "@components/ShowMessage";
import showErrMessage from "@components/ShowErrMessage";
import GlobalLoader from "@components/GlobalLoader";
import OrderConsentCheck from "@components/OrderConsentCheck";

// Ürün/kategori bazında atanmış dinamik sipariş onay kutuları
import useOrderConsents from "@hooks/useOrderConsents";

// react-icons
import { FaTrashAlt, FaTrophy } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// Sözleşme metinleri — hukuk tarafından iletilen 08.09.2026 tarihli nihai
// metinler ("OnBilgilendirmeKosullari_Jarvis Yazılım" /
// "MesafeliSatisSozlesmesi_JarvisYazılım" dokümanları) birebir aktarılmıştır.
// Metinlerdeki [●] işaretleri kaynak dokümanda da boş bırakılan alanlardır;
// hukuk tarafından doldurulduğunda burada da güncellenmelidir.
const AGREEMENTS = {
  preInfo: {
    title: "Ön Bilgilendirme Koşulları",
    html: `
      <h4>ÖN BİLGİLENDİRME KOŞULLARI</h4>

      <h6>1. SATICI BİLGİLERİ</h6>
      <p>
        <strong>Satıcı Unvanı:</strong> Jarvis Yazılım ve Danışmanlık A.Ş. (&ldquo;Satıcı&rdquo; veya &ldquo;JARVIS&rdquo;)<br />
        <strong>Mersis No / Ticaret Sicil No:</strong> 0483124814900001 / 950701-0<br />
        <strong>Adres:</strong> İçerenköy Mah. Topçu İbrahim Sk. Quick Tower Bina No: 8-10D Ataşehir / İstanbul<br />
        <strong>Çağrı Merkezi:</strong> 0850 335 13 58<br />
        <strong>E-posta / KEP:</strong> info@jarvis.com.tr / jarvis@hs01.kep.tr
      </p>
      <p>
        Connection Dükkanı üzerinden verilen ürün siparişlerinde satıcı sıfatı JARVIS'e aittir.
        Cargill Gurme Club [●] (&ldquo;CGC&rdquo;) sadakat programının sahibi ve program/kampanya
        kurallarını belirleyen taraf ise CRG'dir; puan kazanımı, puan kullanım koşulları ve program
        kurallarına ilişkin hususlar program kuralları çerçevesinde yürütülür.
      </p>

      <h6>2. ALICI VE PLATFORM</h6>
      <p>
        İşbu Ön Bilgilendirme Koşulları, yalnızca üyelere açık CGC portalında (&ldquo;Platform&rdquo;)
        yer alan Connection Dükkanı üzerinden sipariş veren üye kullanıcıya (&ldquo;Alıcı&rdquo;)
        yöneliktir. Alıcı, Platform'a üyeliği kapsamında kendisine tanımlanan kullanıcı tipi
        (İşletme veya Usta) ile işlem yapar. Tüketici sıfatı; Alıcı&rsquo;nın işlemi ticari veya
        mesleki amaçlarla mı yoksa kişisel ya da ailevi ihtiyaçları için mi yaptığına göre 6502
        sayılı Tüketicinin Korunması Hakkında Kanun (&ldquo;TKHK&rdquo;) gereği belirlenir.
        Alıcı&rsquo;nın siparişe konu ürünü ticari veya mesleki amaçlarla edinmesi hâlinde TKHK'ya
        özgü hükümler uygulanmaz; tüketici sıfatını haiz Alıcıların kanundan doğan hakları her hâlde
        saklıdır. Bu husus aşağıda kategori bazında açıklanmıştır.
      </p>

      <h6>3. SÖZLEŞME KONUSU ÜRÜN</h6>
      <p>
        Sözleşme konusu ürünün türü, adedi, temel nitelikleri, puan değeri ve varsa nakit ödeme
        tutarı, sipariş onay ekranında Alıcı&rsquo;ya gösterilen bilgilerden ibarettir ve bu bilgiler
        işbu metnin ayrılmaz parçasıdır. Ürün görselleri tanıtım amaçlıdır; gerçek ürün ile görsel
        arasında renk, boy, şekil, baskı gibi fiziksel farklılıklar bulunabilir. Ürünler tedarikçi
        stoğu ile sınırlıdır. Tedarik sorunu yaşanması hâlinde Satıcı, Alıcı&rsquo;yı bilgilendirmek
        suretiyle muadil veya bir üst model ürün gönderebilir; Alıcı&rsquo;nın bunu kabul etmemesi
        hâlinde sipariş iptal edilerek bedel ve puan iadesi 8. maddedeki esaslara göre yapılır.
      </p>

      <h6>4. ÖDEME VE FATURA</h6>
      <p>
        Ürünler, ilgili üründe belirtilen puan değeri karşılığında yalnızca puanla veya puan + nakit
        ödemenin birlikte kullanıldığı karma yöntemle temin edilir. Karma ödemede bedelin puanla
        karşılanan kısmı Alıcı&rsquo;nın puan hesabından işlem anında düşülür; kalan nakit kısım,
        ödeme altyapısı üzerinden Satıcı&rsquo;ya ait sanal POS aracılığıyla tahsil edilir.
      </p>
      <p>
        Bedelin nakit kısmına ilişkin fatura Satıcı tarafından doğrudan Alıcı&rsquo;ya düzenlenir.
        Bedelin puanla karşılanan kısmı program kapsamında ayrıca belgelendirilir; bu kısım için
        Alıcı&rsquo;dan herhangi bir ödeme talep edilmez.
      </p>

      <h6>5. TESLİMAT</h6>
      <p>
        Kargo ücretsizdir. Teslimat, sipariş tarihinden itibaren en geç 30 (otuz) gün içinde,
        siparişte belirtilen teslimat adresine yapılır. Teslim sırasında pakette veya üründe hasar
        tespit edilmesi hâlinde, kargo yetkilisi ile birlikte hasar tespit tutanağı tutulması ve
        ardından 0850 335 13 58 numaralı Çağrı Merkezi üzerinden iade sürecinin başlatılması
        esastır. Tutanak düzenlenmemiş olması, Alıcı&rsquo;nın ayıba ilişkin kanuni haklarını
        kullanmasına engel değildir.
      </p>

      <h6>6. CAYMA HAKKI</h6>
      <p>
        Tüketici sıfatını haiz Alıcı, aşağıdaki istisnalar saklı kalmak üzere, ürünün kendisine veya
        gösterdiği adresteki kişiye tesliminden itibaren 14 (on dört) gün içinde herhangi bir gerekçe
        göstermeksizin ve cezai şart ödemeksizin cayma hakkını kullanabilir. Cayma bildirimi, süresi
        içinde [●] e-posta adresine veya Platform üzerindeki cayma talebi ekranı aracılığıyla, yazılı
        olarak ya da kalıcı veri saklayıcısı ile yapılabilir. Alıcı dilerse Mesafeli Sözleşmeler
        Yönetmeliği ekinde yer alan örnek cayma formunu kullanabilir; bu formun kullanılması zorunlu
        değildir. Talep ayrıca Çağrı Merkezi (0850 335 13 58) üzerinden de iletilebilir. Cayma hâlinde
        ürünün, faturası ve varsa standart aksesuarları ile birlikte, [●] kargo firması aracılığıyla
        iadesi gerekir; bu yolla yapılan iadelerde kargo bedeli Alıcı&rsquo;ya yansıtılmaz. Ambalajın
        açılmış olması, tek başına cayma hakkının kullanılmasına engel değildir.
      </p>
      <p>Ürün kategorilerine göre cayma ve iade rejimi aşağıdaki gibidir:</p>
      <p>
        <strong>a) Arçelik Grubu Ürünleri</strong> (Arçelik, Grundig ve Beko markalı beyaz eşya ve
        elektronik ürünler): Tüketici sıfatını haiz Alıcılar 14 günlük cayma hakkına sahiptir.
        Garanti, bakım ve satış sonrası hizmetler ilgili üretici/ithalatçı ve yetkili servis ağı
        tarafından sağlanır; Alıcı, ayıp ve garanti taleplerini doğrudan yetkili servis kanalları
        üzerinden veya Çağrı Merkezi aracılığıyla iletebilir.
      </p>
      <p>
        <strong>b) İnoksan Ürünleri</strong> (endüstriyel mutfak ekipmanı): Bu kategorideki ürünler
        ağırlıklı olarak mesleki ve ticari kullanıma yöneliktir. Ürünü ticari veya mesleki amaçlarla
        edinen Alıcılar, TKHK m. 3 anlamında tüketici sayılmadığından cayma hakkına ilişkin
        hükümlerden yararlanamaz; bu Alıcılar, teslim aldıkları ürünü makul süre içinde muayene etmek
        ve varsa ayıpları derhâl bildirmekle yükümlüdür. Ürünü kişisel veya ailevi ihtiyaçları için
        edinen ve tüketici sıfatını haiz Alıcıların kanundan doğan cayma hakkı saklıdır. Alıcı,
        sipariş ekranında ürünün ediniliş amacına ilişkin beyanda bulunabilir; kurulum, montaj ve
        garanti koşulları ürün özelinde ayrıca bildirilir.
      </p>
      <p>
        <strong>c) Pluxee Dijital Kodları</strong> (ön ödemeli hediye çeki): Dijital kodlar, siparişin
        onaylanmasıyla birlikte elektronik ortamda anında ifa edilen ve Alıcı&rsquo;ya anında teslim
        edilen gayri maddi ürün niteliğindedir. Mesafeli Sözleşmeler Yönetmeliği'nin 15/1-ğ maddesi
        uyarınca bu ürünlerde cayma hakkı bulunmamaktadır. Alıcı, sipariş onayı ile birlikte cayma
        hakkının bulunmadığını kabul ettiğini beyan eder. Kodların kullanımı, ihraççı Pluxee Çalışan
        Deneyimi Danışmanlık ve Pazarlama A.Ş'nin [●] kullanım koşullarına tabidir.
      </p>
      <p>
        <strong>d) Standart Ürünler</strong> (promosyon / katalog ürünleri): Tüketici sıfatını haiz
        Alıcılar 14 günlük cayma hakkına sahiptir. Stok durumuna bağlı muadil ürün uygulaması 3.
        maddede belirtilen esaslara tabidir.
      </p>
      <p>
        <strong>e) Elektronik ve Teknoloji Ürünleri</strong> (cep telefonu, tablet, bilgisayar, çevre
        birimleri ve benzeri): Bu ürünleri ticari veya mesleki amaçlarla edinen Alıcılar, TKHK m. 3
        anlamında tüketici sayılmadığından cayma hakkına ilişkin hükümlerden yararlanamaz; bu
        Alıcılar, ürünü teslimden itibaren makul süre içinde muayene etmek ve varsa ayıpları derhâl
        Satıcı&rsquo;ya bildirmekle yükümlüdür. Ürünü kişisel veya ailevi ihtiyaçları için edinen ve
        tüketici sıfatını haiz Alıcılar 14 günlük cayma hakkına sahiptir. Alıcı, sipariş ekranında
        ürünün ediniliş amacına ilişkin beyanda bulunabilir. Bu ürünlerde garanti, bakım ve satış
        sonrası hizmetler ilgili üretici/ithalatçı ve yetkili servis ağı tarafından sağlanır.
      </p>

      <h6>7. CAYMA HAKKININ KULLANILAMAYACAĞI DİĞER HÂLLER</h6>
      <p>
        Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesi uyarınca; Alıcı&rsquo;nın istekleri veya
        kişisel ihtiyaçları doğrultusunda hazırlanan ürünlere, tesliminden sonra ambalaj, bant, mühür,
        paket gibi koruyucu unsurları açılmış olup iadesi sağlık ve hijyen açısından uygun olmayan
        ürünlere, tesliminden sonra başka ürünlerle karışan ve doğası gereği ayrıştırılması mümkün
        olmayan ürünlere ve elektronik ortamda anında ifa edilen hizmetler ile anında teslim edilen
        gayri maddi mallara ilişkin sözleşmelerde cayma hakkı kullanılamaz.
      </p>

      <h6>8. BEDEL VE PUAN İADESİ</h6>
      <p>
        Cayma hakkının usulüne uygun kullanılması veya siparişin iptali hâlinde; bedelin nakit kısmı,
        ürünün iade için Satıcı tarafından bildirilen taşıyıcıya teslim edildiği tarihten itibaren 14
        gün içinde, ödemenin yapıldığı ödeme aracına iade edilir. Ürünün, bildirilenin haricinde bir
        taşıyıcı ile iade edilmesi hâlinde bu süre ürünün Satıcı&rsquo;ya ulaştığı tarihte başlar.
        Bedelin puanla karşılanan kısmına isabet eden puanlar da aynı süre içinde Alıcı&rsquo;nın
        Platform'daki puan hesabına iade edilir. Puan iadesi ile nakit iadesi teknik olarak ayrı
        süreçlerde gerçekleşebilir; her hâlde her iki iade de yukarıda belirtilen 14 günlük süre
        içinde tamamlanır. İade edilen puanların geçerlilik süresi, iade tarihinden itibaren yeniden
        işlemeye başlar.
      </p>

      <h6>9. KAMPANYA, SİPARİŞ ADEDİ VE PUAN GEÇERLİLİĞİ</h6>
      <p>
        Kampanya dönemleri, kişi başı sipariş adedi sınırları ve puanların geçerlilik süreleri,
        Platform'da ilan edilen güncel program kuralları ve sipariş ekranında gösterilen koşullar
        çerçevesinde uygulanır. Alıcı, sipariş anında Platform'da yayımlanan güncel koşulların
        uygulanacağını kabul eder.
      </p>

      <h6>10. KİŞİSEL VERİLER</h6>
      <p>
        Sipariş, faturalama, tahsilat ve teslimat süreçlerinde işlenen kişisel veriler bakımından veri
        sorumlusu, satıcı sıfatıyla JARVIS'tir. Ayrıntılı bilgi için sipariş ekranında yer alan
        Aydınlatma Metni'ni inceleyebilirsiniz.
      </p>

      <h6>11. UYUŞMAZLIKLARIN ÇÖZÜMÜ</h6>
      <p>
        Tüketici sıfatını haiz Alıcılar, uyuşmazlık hâlinde Ticaret Bakanlığınca her yıl ilan edilen
        parasal sınırlar dâhilinde yerleşim yerlerinin bulunduğu veya işlemin yapıldığı yerdeki
        Tüketici Hakem Heyetlerine başvurabilir; bu parasal sınırların üzerindeki uyuşmazlıklarda ise
        TKHK m. 73/A uyarınca dava açılmadan önce arabulucuya başvurulması şartıyla Tüketici
        Mahkemelerine başvurabilir. Tüketici sıfatını haiz olmayan Alıcılar bakımından İstanbul
        (Çağlayan) Mahkemeleri ve İcra Daireleri yetkilidir.
      </p>

      <h6>12. ONAY</h6>
      <p>
        Alıcı, işbu Ön Bilgilendirme Koşulları'nı sipariş onayından önce Platform üzerinde okuyup
        elektronik ortamda onayladığını, ürünün temel nitelikleri, puan değeri, varsa nakit satış
        bedeli, ödeme ve teslimat koşulları ile cayma hakkına ilişkin ön bilgilendirmeyi edindiğini
        kabul ve beyan eder.
      </p>
    `,
  },
  distanceSale: {
    title: "Mesafeli Satış Sözleşmesi",
    html: `
      <h4>MESAFELİ SATIŞ SÖZLEŞMESİ</h4>

      <h6>1. TARAFLAR</h6>
      <p>
        İşbu Mesafeli Satış Sözleşmesi (&ldquo;Sözleşme&rdquo;); aşağıda bilgileri yer alan Satıcı ile
        [●] portalı Connection Dükkanı üzerinden sipariş veren ve sipariş ekranında bilgileri yer alan
        Alıcı arasında, aşağıdaki koşullarla elektronik ortamda kurulmuştur.
      </p>
      <p>
        <strong>Satıcı Unvanı:</strong> Jarvis Yazılım ve Danışmanlık A.Ş. (&ldquo;Satıcı&rdquo; veya &ldquo;JARVIS&rdquo;)<br />
        <strong>Mersis No / Ticaret Sicil No:</strong> 0483124814900001 / 950701-0<br />
        <strong>Adres:</strong> İçerenköy Mah. Topçu İbrahim Sk. Quick Tower Bina No: 8-10D Ataşehir / İstanbul<br />
        <strong>Çağrı Merkezi:</strong> 0850 335 13 58<br />
        <strong>E-posta / KEP:</strong> info@jarvis.com.tr / jarvis@hs01.kep.tr
      </p>
      <p>
        <strong>Alıcı:</strong> Sipariş ekranında ad-soyad/unvan, teslimat adresi ve iletişim
        bilgileri yer alan Platform üyesidir.
      </p>

      <h6>2. KONU</h6>
      <p>
        İşbu Sözleşme'nin konusu; Alıcı&rsquo;nın, Satıcı&rsquo;ya ait olmayan ancak Satıcı tarafından
        satışa sunulan ve nitelikleri ile satış koşulları sipariş ekranında belirtilen ürünün satışı
        ve teslimi ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli
        Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerinin
        belirlenmesidir. Alıcı&rsquo;nın tüketici sıfatını haiz olmadığı işlemlerde, tüketici
        mevzuatına özgü hükümler yerine genel hükümler uygulanır.
      </p>

      <h6>3. SÖZLEŞME KONUSU ÜRÜN</h6>
      <p>
        Ürünün türü, adedi, temel nitelikleri, puan değeri ve varsa nakit satış bedeli (vergiler
        dâhil), sipariş onay ekranında yer aldığı şekildedir ve işbu Sözleşme'nin ayrılmaz parçasıdır.
        Ürün görselleri tanıtım amaçlı olup gerçek ürün ile görsel arasında renk, boy, şekil, baskı
        gibi fiziksel farklılıklar bulunabilir.
      </p>

      <h6>4. GENEL HÜKÜMLER</h6>
      <p>
        Alıcı; ürünün temel nitelikleri, puan değeri, varsa nakit satış bedeli, ödeme şekli ve
        teslimata ilişkin Ön Bilgilendirme Koşulları'nı okuyup bilgi sahibi olduğunu ve elektronik
        ortamda gerekli teyidi verdiğini kabul ve beyan eder.
      </p>
      <p>
        Sipariş, Alıcı&rsquo;nın Platform üzerinde işbu Sözleşme'yi ve Ön Bilgilendirme Koşulları'nı
        ayrı ayrı onaylayarak &ldquo;Siparişi Onayla&rdquo; adımını tamamlamasıyla kurulur. Platform
        kayıtları, sistem logları ve elektronik onay kayıtları kesin delil niteliğindedir.
      </p>
      <p>
        Tüketici sıfatı, Alıcı&rsquo;nın işlemi ticari veya mesleki amaçlarla mı yoksa kişisel ya da
        ailevi ihtiyaçları için mi yaptığına göre kanun gereği belirlenir. Alıcı, sipariş ekranında
        ürünü hangi amaçla edindiğine ilişkin beyanda bulunabilir; bu beyan, tarafların hak ve
        yükümlülüklerinin belirlenmesinde dikkate alınır. Her hâlde, tüketici sıfatını haiz Alıcıların
        ilgili mevzuattan doğan hakları saklıdır.
      </p>

      <h6>5. ÖDEME VE FATURA</h6>
      <p>
        Ürün bedeli, sipariş ekranında belirtilen puan değeri karşılığında yalnızca puanla veya puan +
        nakit karma yöntemle ödenir. Karma ödemede bedelin puanla karşılanan kısmı Alıcı&rsquo;nın
        puan hesabından işlem anında düşülür; nakit kısım, Satıcı&rsquo;ya ait sanal POS altyapısı
        üzerinden tahsil edilir. Alıcı&rsquo;nın ilgili ürün için tanımlanan asgari puan kullanım
        koşulunu sağlaması gerekir; ürün yalnızca nakit ödeme ile satın alınamaz.
      </p>
      <p>
        Bedelin nakit kısmına ilişkin fatura Satıcı tarafından Alıcı&rsquo;ya düzenlenir ve elektronik
        ortamda iletilir. Bedelin puanla karşılanan kısmı için Alıcı&rsquo;dan herhangi bir ödeme
        talep edilmez.
      </p>

      <h6>6. TESLİMAT</h6>
      <p>
        Kargo ücretsizdir. Ürün, sipariş tarihinden itibaren en geç 30 (otuz) gün içinde
        Alıcı&rsquo;nın sipariş ekranında belirttiği teslimat adresine, Satıcı&rsquo;nın anlaşmalı
        kargo firması aracılığıyla teslim edilir. Alıcı&rsquo;nın adreste bulunmaması veya hatalı
        adres bildirmesi hâlinde doğan gecikmelerden Satıcı sorumlu değildir.
      </p>
      <p>
        Teslim sırasında pakette veya üründe hasar tespit edilmesi hâlinde kargo yetkilisi ile birlikte
        hasar tespit tutanağı tutulur ve 0850 335 13 58 numaralı Çağrı Merkezi üzerinden iade süreci
        başlatılır. Tutanak düzenlenmemiş olması, Alıcı&rsquo;nın ayıba ilişkin kanuni haklarını
        kullanmasına engel değildir.
      </p>
      <p>
        Ürünler tedarikçi stoğu ile sınırlıdır. Tedarik sorunu hâlinde Satıcı, Alıcı&rsquo;yı
        bilgilendirerek muadil veya bir üst model ürün gönderebilir; Alıcı&rsquo;nın kabul etmemesi
        hâlinde sipariş iptal edilir ve 8. madde uygulanır.
      </p>

      <h6>7. CAYMA HAKKI</h6>
      <p>
        Tüketici sıfatını haiz Alıcı, aşağıdaki kategori bazlı istisnalar saklı kalmak üzere, ürünün
        teslimini takip eden 14 (on dört) gün içinde herhangi bir gerekçe göstermeksizin ve cezai şart
        ödemeksizin cayma hakkını kullanabilir. Cayma bildirimi, [●] e-posta adresine veya Platform
        üzerindeki cayma talebi ekranı aracılığıyla, yazılı olarak ya da kalıcı veri saklayıcısı ile
        yapılır. Alıcı dilerse Mesafeli Sözleşmeler Yönetmeliği ekinde yer alan örnek cayma formunu
        kullanabilir; bu formun kullanılması zorunlu değildir. Talep ayrıca Çağrı Merkezi
        (0850 335 13 58) üzerinden de iletilebilir. Cayma hâlinde ürün; faturası ve varsa standart
        aksesuarları ile birlikte, mümkün olduğu ölçüde kutusu ve ambalajı ile, [●] kargo firması
        aracılığıyla iade edilir. Ambalajın açılmış olması, tek başına cayma hakkının kullanılmasına
        engel değildir; bu yolla yapılan iadelerde kargo bedeli Alıcı&rsquo;ya yansıtılmaz.
      </p>
      <p>
        <strong>7.1. Arçelik Grubu Ürünleri</strong> (Arçelik, Grundig ve Beko markalı ürünler):
        Tüketici sıfatını haiz Alıcılar 14 günlük cayma hakkına sahiptir. Garanti, bakım ve satış
        sonrası hizmetler üretici/ithalatçı ve yetkili servis ağı tarafından sağlanır.
      </p>
      <p>
        <strong>7.2. İnoksan Ürünleri:</strong> Bu ürünleri ticari veya mesleki amaçlarla edinen
        Alıcılar, TKHK m. 3 anlamında tüketici sayılmadığından cayma hakkına ilişkin hükümlerden
        yararlanamaz; bu Alıcılar, ürünü teslimden itibaren makul süre içinde muayene etmek ve varsa
        ayıpları derhâl Satıcı&rsquo;ya bildirmekle yükümlüdür. Ürünü kişisel veya ailevi ihtiyaçları
        için edinen ve tüketici sıfatını haiz Alıcıların kanundan doğan cayma hakkı saklıdır. Alıcı,
        sipariş ekranında ürünün ediniliş amacına ilişkin beyanda bulunabilir.
      </p>
      <p>
        <strong>7.3. Pluxee Dijital Kodları:</strong> Elektronik ortamda anında ifa edilen ve anında
        teslim edilen gayri maddi mal niteliğindeki dijital kodlarda, Mesafeli Sözleşmeler Yönetmeliği
        m. 15/1-ğ uyarınca cayma hakkı bulunmamaktadır. Alıcı, siparişi onaylamakla bu hususta
        bilgilendirildiğini ve cayma hakkının bulunmadığını kabul eder. Kodların kullanım koşulları
        ihraççı Pluxee Çalışan Deneyimi Danışmanlık ve Pazarlama A.Ş tarafından belirlenir.
      </p>
      <p>
        <strong>7.4. Standart Ürünler:</strong> Tüketici sıfatını haiz Alıcılar 14 günlük cayma
        hakkına sahiptir. Ayrıca; Alıcı&rsquo;nın istekleri doğrultusunda kişiselleştirilen ürünler,
        koruyucu unsurları açıldığında iadesi sağlık ve hijyen açısından uygun olmayan ürünler ve
        mevzuatta sayılan diğer hâllerde cayma hakkı kullanılamaz.
      </p>
      <p>
        <strong>7.5. Elektronik ve Teknoloji Ürünleri</strong> (cep telefonu, tablet, bilgisayar,
        çevre birimleri ve benzeri): Bu ürünleri ticari veya mesleki amaçlarla edinen Alıcılar, TKHK
        m. 3 anlamında tüketici sayılmadığından cayma hakkına ilişkin hükümlerden yararlanamaz; bu
        Alıcılar, ürünü teslimden itibaren makul süre içinde muayene etmek ve varsa ayıpları derhâl
        Satıcı&rsquo;ya bildirmekle yükümlüdür. Ürünü kişisel veya ailevi ihtiyaçları için edinen ve
        tüketici sıfatını haiz Alıcılar 14 günlük cayma hakkına sahiptir. Alıcı, sipariş ekranında
        ürünün ediniliş amacına ilişkin beyanda bulunabilir. Garanti, bakım ve satış sonrası hizmetler
        üretici/ithalatçı ve yetkili servis ağı tarafından sağlanır.
      </p>

      <h6>8. BEDEL VE PUAN İADESİ</h6>
      <p>
        Cayma hakkının usulüne uygun kullanılması veya siparişin iptali hâlinde; (i) nakit ödenen
        kısım, ürünün iade için Satıcı tarafından bildirilen taşıyıcıya teslim edildiği tarihten
        itibaren 14 gün içinde ödemenin yapıldığı ödeme aracına iade edilir; ürünün bildirilenin
        haricinde bir taşıyıcı ile iade edilmesi hâlinde bu süre ürünün Satıcı&rsquo;ya ulaştığı
        tarihte başlar; (ii) bedelin puanla karşılanan kısmına isabet eden puanlar da aynı süre içinde
        Alıcı&rsquo;nın Platform'daki puan hesabına iade edilir. Puan iadesi ile nakit iadesi teknik
        olarak ayrı süreçlerde gerçekleşebilir; her hâlde her iki iade de yukarıda belirtilen 14
        günlük süre içinde tamamlanır. İade edilen puanların geçerlilik süresi, iade tarihinden
        itibaren yeniden işlemeye başlar.
      </p>

      <h6>9. AYIPLI MAL VE GARANTİ</h6>
      <p>
        Ürünlerin ayıplı çıkması hâlinde Alıcı, mevzuattan doğan seçimlik haklarını kullanabilir.
        Garanti belgesi ile satılan ürünlerde garanti, bakım ve onarım hizmetleri ilgili
        üretici/ithalatçı ve yetkili servis istasyonları tarafından sağlanır; Alıcı bu taleplerini
        doğrudan yetkili servis kanallarından veya Çağrı Merkezi aracılığıyla iletebilir. Satıcı, bu
        süreçlerin yürütülmesinde Alıcı&rsquo;ya gerekli desteği sağlar.
      </p>

      <h6>10. MÜCBİR SEBEP</h6>
      <p>
        Tarafların kontrolü dışında gelişen; doğal afet, salgın, yangın, savaş, seferberlik, altyapı
        ve internet arızaları, mevzuat değişiklikleri ve benzeri hâller mücbir sebep sayılır. Mücbir
        sebep süresince tarafların edimleri askıya alınır; mücbir sebebin 30 günden uzun sürmesi
        hâlinde taraflardan her biri siparişi bedelsiz iptal edebilir; bu hâlde 8. madde uygulanır.
      </p>

      <h6>11. KİŞİSEL VERİLERİN KORUNMASI</h6>
      <p>
        Sipariş, faturalama, tahsilat ve teslimat süreçlerinde işlenen kişisel veriler bakımından veri
        sorumlusu, satıcı sıfatıyla JARVIS'tir. Kişisel veriler, 6698 sayılı Kişisel Verilerin
        Korunması Kanunu'na uygun olarak işlenir; ayrıntılı bilgi sipariş ekranında yer alan
        Aydınlatma Metni'nde düzenlenmiştir.
      </p>

      <h6>12. UYUŞMAZLIKLARIN ÇÖZÜMÜ</h6>
      <p>
        Tüketici sıfatını haiz Alıcılar; Ticaret Bakanlığınca ilan edilen parasal sınırlar dâhilinde
        yerleşim yerlerinin bulunduğu veya işlemin yapıldığı yerdeki Tüketici Hakem Heyetlerine
        başvurabilir; bu parasal sınırların üzerindeki uyuşmazlıklarda ise TKHK m. 73/A uyarınca dava
        açılmadan önce arabulucuya başvurulması şartıyla Tüketici Mahkemelerine başvurabilir. Tüketici
        sıfatını haiz olmayan Alıcılar bakımından işbu Sözleşme'den doğan uyuşmazlıklarda İstanbul
        (Çağlayan) Mahkemeleri ve İcra Daireleri yetkilidir.
      </p>

      <h6>13. YÜRÜRLÜK</h6>
      <p>
        Alıcı, işbu Sözleşme'nin tüm koşullarını Platform üzerinde okuyup kabul ettiğini, Ön
        Bilgilendirme Koşulları'nı ayrıca onayladığını ve siparişi onaylamakla ödeme yükümlülüğü
        altına girdiğini kabul ve beyan eder. İşbu Sözleşme, Alıcı&rsquo;nın elektronik ortamda onayı
        ile kurulmuş ve yürürlüğe girmiştir.
      </p>
    `,
  },
};

const Cart = () => {
  const dispatch = useDispatch();
  const loginSettings = useSelector((store) => store.auth.loginSettings);
  let cartData = useSelector((store) => store.cart.cartData);
  const profileDetail = useSelector((store) => store.profile.profileDetail);
  const addressData = useSelector((store) => store.profile.address);
  const isLoading = useSelector((store) => store.order.isLoading);
  const scoreCurrency = useSelector((store) => store.order.scoreCurrency);
  const minimumScoreRatioForPayment = useSelector(
    (store) => store.order.minimumScoreRatioForPayment
  );
  const paymentModule = useSelector((store) => store.cart.paymentModule);

  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validatedForm, setValidatedForm] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [orderSuccessTimer, setOrderSuccessTimer] = useState(false);
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  // Açık sözleşme modalı: null | "preInfo" (Ön Bilgilendirme Koşulları) |
  // "distanceSale" (Mesafeli Satış Sözleşmesi)
  const [agreementModal, setAgreementModal] = useState(null);
  // Dinamik onay kutularında eksik onay uyarısını (kırmızı) göster.
  const [showConsentErrors, setShowConsentErrors] = useState(false);

  // Sepet satırlarına atanmış dinamik onay kutuları. Kural kategori veya tekil
  // ürün (SKU) seviyesinde tanımlanır; hangisinin uygulanacağını backend çözümler
  // (ürün > kategori). Atanmamışsa satırda kutu çıkmaz.
  const {
    isChecked: isConsentChecked,
    toggle: toggleConsent,
    missingCount: missingConsentCount,
    allAccepted: allConsentsAccepted,
    acknowledgements: consentAcknowledgements,
  } = useOrderConsents(cartData?.cartProductDTOList);

  const schema = yup.object({
    address: yup.string().required("Lütfen Adres Seçiniz!"),
    agreement: yup
      .bool()
      .required()
      .oneOf(
        [true],
        "Şartlar ve koşullar sözleşmelerini kabul etmek zorundasınız!"
      ),
    paymentAgreement: yup
      .bool()
      .required()
      .oneOf([true], "Ödeme sözleşmesini kabul etmek zorundasınız!"),
  });

  const formRef = useRef(null);

  useEffect(() => {
    dispatch(cartAction.getCart());
    dispatch(profileAction.getAddress());
    dispatch(orderAction.getScoreCurrency("ORDER"));
    dispatch(cartAction.getPaymentModule("SCORE_CURRENCY_CONVERSION"));

    return () => {};
  }, []);

  useEffect(() => {
    if (addressData && addressData.length > 0) {
      const filteredData = addressData
        .filter((address) => address.orderAddress === true)
        .map((filteredAddress) => filteredAddress.addressId);

      setSelectedAddress(filteredData[0]);
    }

    return () => {};
  }, [addressData]);

  const handleSubmitOrder = (values) => {
    // Form validasyonunu buraya ekleyelim
    if (!values.address || !values.agreement || !values.paymentAgreement) {
      showErrMessage(
        "Lütfen adres seçiniz, sözleşmeyi kabul ediniz ve ödeme sözleşmesini kabul ediniz!"
      );
      return;
    }

    // Ürüne/kategorisine atanmış onay kutuları işaretlenmeden sipariş ilerlemez.
    // Bu kutular genel şartlar / mesafeli satış sözleşmesi onayından ayrıdır.
    if (!allConsentsAccepted) {
      setShowConsentErrors(true);
      showErrMessage(
        missingConsentCount > 1
          ? `Sepetinizdeki ${missingConsentCount} ürün için gösterilen onayları vermeniz gerekmektedir.`
          : "Sepetinizdeki ürün için gösterilen onayı vermeniz gerekmektedir."
      );
      return;
    }

    //dispatch( cartAction.addToCart() );
    if (remainingAmount < 0 && values.address && values.paymentAgreement) {
      if (isScoreRatioInsufficient) {
        showErrMessage(
          `Ödemeye geçebilmek için mevcut puanınız en az ${Math.ceil(
            requiredMinimumScore
          )} olmalıdır.`
        );
        return;
      }

      const returnUrl = window.location.origin;

      setIsSubmitting(true);
      dispatch(
        orderAction.confirmPayment(
          values.address,
          true,
          returnUrl,
          consentAcknowledgements
        )
      )
        .then((e) => {
          if (e.isHttpSuccess && e.data.token) {
            localStorage.setItem("paymentToken", e.data.token);
            localStorage.setItem("isOrderForCatalog", true);
            showMessage(
              "Ödeme işlemi başlatıldı. Ödeme sayfasına yönlendiriliyorsunuz..."
            );
            dispatch(shopAction.getBrandCartList());
            dispatch(cartAction.getCart());
            //   setOrderSuccess(true);

            window.location.href = e.data.url;
            setTimeout(() => {
              setOrderSuccessTimer(true);
            }, 100);
          } else {
            showErrMessage("Ödeme işlemi başlatılamadı!");
          }
        })
        .catch((err) => {
          const errors = err?.error?.response?.data?.errors;
          if (Array.isArray(errors) && errors.length > 0) {
            errors.forEach((item) => {
              showErrMessage(item.message);
            });
          } else {
            showErrMessage(err?.message || "İşlem başarısız.");
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    } else {
      setIsSubmitting(true);
      dispatch(
        orderAction.createOrder(
          "EMPLOYEE",
          "KAMPANYA",
          selectedAddress,
          "test",
          false,
          values.agreement,
          consentAcknowledgements
        )
      )
        .then((e) => {
          if (e.isHttpSuccess) {
            localStorage.setItem("PayWithScore", true);
            // Hediye çeki siparişinde tamamlanma ekranı farklı (SMS ile kod gönderildi).
            if (e.data?.giftCardOrder) {
              localStorage.setItem("giftCardOrder", "true");
            } else {
              localStorage.removeItem("giftCardOrder");
            }

            showMessage(
              "Siparişiniz başarıyla alındı. Profil Siparişlerim sayfasından takip edebilirsiniz!"
            );
            window.location.href = "/order-summary";
            //setOrderSuccess(true);
            setTimeout(() => {
              dispatch(cartAction.getCart());
              //setOrderSuccessTimer(true);
            }, 4000);
          }
        })
        .catch((err) => {
          const errors = err?.error?.response?.data?.errors;
          if (Array.isArray(errors) && errors.length > 0) {
            errors.forEach((item) => {
              showErrMessage(item.message);
            });
          } else {
            showErrMessage(err?.message || "İşlem başarısız.");
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
    setValidatedForm(true);
  };

  const handleRemoveCartItem = (e, id) => {
    if (e !== null) {
      e.preventDefault();
    }

    dispatch(cartAction.removeCartItemById(id))
      .then((response) => {
        if (response.isHttpSuccess) {
          showMessage(`Ürün sepetten kaldırıldı!`);
          setTimeout(() => {
            dispatch(cartAction.getCart());
          }, 1000);
        }
      })
      .catch((err) => {
        if (err.isHttpError) {
          showErrMessage(`Üzgünüz. Ürün sepetten kaldırılamadı!`);
        }

        console.log("err: ", err);
      });
  };

  const handleMinus = (item) => {
    if (item.productCount > 1) {
      dispatch(
        shopAction.addToCart(item.product.id, item.productCount - 1, false)
      )
        .then((response) => {
          if (response.isHttpSuccess) {
            dispatch(cartAction.getCart());
          }
        })
        .catch((err) => {
          showErrMessage(err.message);
        });
    } else {
      handleRemoveCartItem(null, item.id);
    }
  };

  const handlePlus = (id, productCount, stock) => {
    if (productCount < stock) {
      dispatch(shopAction.addToCart(id, 1, true))
        .then((response) => {
          if (response.isHttpSuccess) {
            dispatch(cartAction.getCart());
          }
        })
        .catch((err) => {
          showErrMessage(err.message);
        });
    }
  };

  const handleRemoveAllItems = (e) => {
    // Form submit'i engellemek için
    e.preventDefault();
    e.stopPropagation();

    dispatch(cartAction.removeAllItems())
      .then((response) => {
        if (response.isHttpSuccess) {
          showMessage(`Tüm ürünler sepetten kaldırıldı!`);
          dispatch(cartAction.getCart());
        }
      })
      .catch((err) => {
        if (err.isHttpError) {
          showErrMessage(`Üzgünüz. Tüm ürünler sepetten kaldırılamadı!`);
        }
      });
  };

  const remainingAmount = profileDetail?.score - cartData?.totalScore;
  const paymentAmount = scoreCurrency * Math.abs(remainingAmount);

  // Minimum puan kontrolü (ürün bazlı ağırlıklı toplam):
  // Gereken puan = Σ (ürün puanı × adet × etkin oran / 100).
  // Etkin oran: ürünün kendi minimumScoreRatioForPayment'i varsa o; yoksa genel
  // (ScoreCurrencyConversion ORDER) değeri. Hiç oran yoksa gereken puan 0 → kontrol devre dışı.
  const requiredMinimumScore = (cartData?.cartProductDTOList || []).reduce(
    (sum, item) => {
      const productScore = Number(item?.product?.score) || 0;
      const count = Number(item?.productCount) || 0;
      const effectiveRatio =
        item?.product?.minimumScoreRatioForPayment != null
          ? Number(item.product.minimumScoreRatioForPayment)
          : Number(minimumScoreRatioForPayment) || 0;
      return sum + (productScore * count * effectiveRatio) / 100;
    },
    0
  );
  const isScoreRatioInsufficient =
    requiredMinimumScore > 0 &&
    (profileDetail?.score || 0) < requiredMinimumScore;

  // Etkin oran 100 ise ürün tamamen puan ile alınır; kart ile ödeme yapılamaz.
  // (Etkin oran: ürünün kendi minimumScoreRatioForPayment'i varsa o; yoksa genel
  // ORDER değeri — requiredMinimumScore ile aynı mantık.) Bu durumda kart tutarı
  // gizlenir, bilgilendirme metni güncellenir ve "Ödemeye Geç" yerine
  // "Siparişi Tamamla" gösterilir.
  const cartProducts = cartData?.cartProductDTOList || [];
  const isFullScorePayment =
    cartProducts.length > 0 &&
    cartProducts.every((item) => {
      const effectiveRatio =
        item?.product?.minimumScoreRatioForPayment != null
          ? Number(item.product.minimumScoreRatioForPayment)
          : Number(minimumScoreRatioForPayment) || 0;
      return effectiveRatio === 100;
    });

  return (
    <>
      <Header />

      <main>
        <section className="bg-blue py-5 mb-5">
          <div className="container">
            <h1 className="text-white mb-0 text-center">Sipariş Oluştur</h1>
          </div>
        </section>

        {cartData && cartData?.cartProductDTOList?.length > 0 ? (
          <section className="my-5">
            {orderSuccess ? (
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-7 col-md-10">
                    <div className="bg-gray-lightest rounded-3 p-5 text-center mb-5">
                      <h3 className="mb-5 text-green">
                        🎉 Siparişiniz Alındı!
                      </h3>
                      <p className="lead mb-5">
                        Hediyeniz <strong>15 iş günü</strong> içerisinde kargo
                        aracılığıyla size ulaşacaktır. İyi Günlerde Kullanın!
                      </p>
                      <Link
                        to="/profile/orders"
                        className="btn btn-green text-white rounded-pill py-sm-3 py-2 px-sm-4 px-3"
                      >
                        Ödül Siparişlerim
                      </Link>
                    </div>
                    <p className="small fw-light opacity-75 text-center">
                      Siparişiniz ile ilgili sorularınız için Sıkça Sorulan
                      Sorular bölümünden yardım alabilir, Cargill Gurme Club Çağrı
                      Merkezi'ni 0850 335 1358 nolu telefondan Pazartesi ila
                      Cuma günleri 09:00-18:00 saatleri arasında arayabilir veya
                      Bize Ulaşın'dan bize erişebilirsiniz.
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <Formik
                validationSchema={schema}
                onSubmit={(values, { resetForm }) =>
                  handleSubmitOrder(values, { resetForm })
                }
                initialValues={{
                  address: "",
                  agreement: false,
                  paymentAgreement: false,
                }}
                validate={(values) => {
                  const errors = {};
                  if (!values.address) {
                    errors.address = "Lütfen Adres Seçiniz!";
                  }
                  if (!values.agreement) {
                    errors.agreement =
                      "Şartlar ve koşullar sözleşmelerini kabul etmek zorundasınız!";
                  }
                  if (!values.paymentAgreement) {
                    errors.paymentAgreement =
                      "Ödeme sözleşmesini kabul etmek zorundasınız!";
                  }

                  return errors;
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <Form
                    ref={formRef}
                    className="form-address"
                    noValidate
                    onSubmit={(e) => {
                      if (
                        !values.address ||
                        !values.agreement ||
                        !values.paymentAgreement
                      ) {
                        e.preventDefault();
                        showErrMessage(
                          "Lütfen adres seçiniz, sözleşmeyi kabul ediniz ve ödeme sözleşmesini kabul ediniz!"
                        );
                      }
                      if (!allConsentsAccepted) {
                        setShowConsentErrors(true);
                      }
                      handleSubmit(e);
                    }}
                  >
                    <div className="container">
                      <div className="row justify-content-center gx-5 gy-5">
                        <div className="col-xl-8 col-lg-8">
                          <h5 className="mb-4 text-blue uppercase">Sepetim</h5>
                          {cartData && cartData.cartProductDTOList.length > 0
                            ? cartData.cartProductDTOList.map((item) => {
                                return (
                                  /* align-items-start: onay kutusundaki "Daha fazla
                                     bilgi al" paneli açılınca satır uzuyor; ortalı
                                     hizada görsel aşağı kayıyordu. */
                                  <div
                                    className="d-flex align-items-start border-bottom pb-5 mb-5"
                                    key={item.id}
                                  >
                                    {item?.product?.productContentUrlList &&
                                    item?.product?.productContentUrlList
                                      .length > 0 ? (
                                      <img
                                        src={
                                          item?.product
                                            ?.productContentUrlList[0]
                                            .baseAddress
                                        }
                                        alt=""
                                        className="img-contain rounded-3 shadow-lg"
                                        style={{
                                          width: "200px",
                                          height: "150px",
                                        }}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          height: "150px",
                                          background: "#000",
                                        }}
                                      >
                                        {loginSettings?.logo && (
                                          <img
                                            src={loginSettings?.logo}
                                            alt=""
                                            className="w-100 opacity-50"
                                            style={{
                                              height: "150px",
                                              objectFit: "scale-down",
                                            }}
                                          />
                                        )}
                                      </div>
                                    )}

                                    <div className="ms-4 d-flex w-100 flex-column">
                                      <h6>{item.product.name}</h6>
                                      {item.product.description ? (
                                        <p className="mt-3 mb-0 fw-light opacity-75">
                                          {item.product.description}
                                        </p>
                                      ) : null}

                                      <div>
                                        <div className="shopping-cart-point my-2 d-flex align-items-center w-100">
                                          <FaTrophy className="d-inline-block me-2 text-green" />
                                          <span className="d-inline-block">
                                            {item.product.score}
                                          </span>
                                          <div
                                            style={{
                                              marginLeft: "auto",
                                              fontSize: "20px",
                                            }}
                                            className="cursor-pointer text-red"
                                          >
                                            <FaTrashAlt
                                              className="text-red"
                                              onClick={(e) =>
                                                handleRemoveCartItem(e, item.id)
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="d-flex align-items-center">
                                          <button
                                            type="button"
                                            style={{ fontSize: "24px" }}
                                            className="btn btn-outline-secondary btn-sm me-2 "
                                            onClick={() => handleMinus(item)}
                                          >
                                            -
                                          </button>
                                          <span
                                            style={{ fontSize: "20px" }}
                                            className="me-2"
                                          >
                                            {item.productCount}
                                          </span>
                                          <button
                                            type="button"
                                            style={{ fontSize: "24px" }}
                                            className="btn btn-outline-secondary btn-sm me-2"
                                            onClick={() =>
                                              handlePlus(
                                                item.product.id,
                                                item.productCount,
                                                item.product.stock
                                              )
                                            }
                                          >
                                            +
                                          </button>
                                        </div>

                                        {/* Ürüne/kategorisine atanmış dinamik
                                            onay kutusu. Atanmamışsa hiçbir şey
                                            çizilmez. */}
                                        <OrderConsentCheck
                                          consent={item.consent}
                                          checked={isConsentChecked(item.id)}
                                          onChange={(value) =>
                                            toggleConsent(item.id, value)
                                          }
                                          showError={showConsentErrors}
                                          inputId={`orderConsent-${item.id}`}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            : null}

                          <Form.Group controlId="changePasswordFormValidation">
                            <h5 className="mb-4 d-flex justify-content-between align-self-center">
                              <span className="text-blue">Teslimat Adresi</span>
                              <Link
                                to="/profile/address"
                                className="fs-6 text-green"
                              >
                                <small>Yeni Adres Ekle</small>
                              </Link>
                            </h5>

                            <div className="row gy-3 row-cols-md-1 row-cols-1 align-items-start">
                              <div className="col">
                                <Form.Control
                                  as="select"
                                  className="form-control"
                                  autoComplete="chrome-off"
                                  placeholder="Teslimat Adresi Seçiniz"
                                  onChange={(e) => {
                                    handleChange(e);
                                    setSelectedAddress(e.target.value);
                                  }}
                                  onBlur={handleBlur}
                                  name="address"
                                  value={values.address}
                                  isInvalid={
                                    touched.address && !!errors.address
                                  }
                                >
                                  <option value="">Seçiniz</option>
                                  {addressData?.map((item, i) => (
                                    <option value={item.addressId} key={i}>
                                      {item.name}
                                    </option>
                                  ))}
                                </Form.Control>

                                <Form.Control.Feedback
                                  className="FeedBack"
                                  type="invalid"
                                >
                                  {errors.address &&
                                    touched.address &&
                                    errors.address}
                                </Form.Control.Feedback>
                              </div>

                              <Form.Group>
                                <Form.Label></Form.Label>
                                <Form.Check
                                  onChange={(e) => {
                                    handleChange(e);
                                    touched.paymentAgreement = true;
                                  }}
                                  onBlur={handleBlur}
                                  name="paymentAgreement"
                                  checked={values.paymentAgreement}
                                  isInvalid={
                                    touched.paymentAgreement &&
                                    !!errors.paymentAgreement
                                  }
                                  id="paymentAgreement"
                                  label={
                                    <>
                                      <a
                                        className="text-orange cursor-pointer text-decoration-underline"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setAgreementModal("preInfo");
                                        }}
                                      >
                                        Ön Bilgilendirme Koşulları
                                      </a>
                                      'nı okudum, onaylıyorum.
                                    </>
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.paymentAgreement &&
                                    touched.paymentAgreement &&
                                    errors.paymentAgreement}
                                </Form.Control.Feedback>
                              </Form.Group>

                              <Form.Group>
                                <Form.Label></Form.Label>
                                <Form.Check
                                  onChange={(e) => {
                                    handleChange(e);
                                    touched.agreement = true;
                                  }}
                                  onBlur={handleBlur}
                                  name="agreement"
                                  checked={values.agreement}
                                  isInvalid={
                                    touched.agreement && !!errors.agreement
                                  }
                                  id="agreement"
                                  label={
                                    <>
                                      <a
                                        className="text-orange cursor-pointer text-decoration-underline"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setAgreementModal("distanceSale");
                                        }}
                                      >
                                        Mesafeli Satış Sözleşmesi
                                      </a>
                                      'ni okudum, onaylıyorum.
                                    </>
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.agreement &&
                                    touched.agreement &&
                                    errors.agreement}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                          </Form.Group>
                        </div>

                        <div className="col-xl-4 col-lg-4">
                          <div className="bg-gray-lightest rounded-3 p-4">
                            <h5 className="mb-4">Sipariş Özeti</h5>
                            <div className="d-flex justify-content-between border-bottom py-3 small">
                              <div>Mevcut Puanınız</div>
                              <div>
                                {profileDetail?.score >= 1000
                                  ? profileDetail?.score.toLocaleString("tr-TR")
                                  : profileDetail?.score}
                              </div>
                            </div>
                            <div className="d-flex justify-content-between border-bottom py-3 small">
                              <div>Sipariş Tutarı (Puan)</div>
                              <div>
                                {cartData?.totalScore >= 1000
                                  ? cartData?.totalScore.toLocaleString("tr-TR")
                                  : cartData?.totalScore}
                              </div>
                            </div>

                            {remainingAmount < 0 &&
                              paymentModule &&
                              !isFullScorePayment && (
                                <div className="d-flex justify-content-between py-3 small text-blue">
                                  <div>Kartınızdan tahsil edilecek tutar</div>
                                  <div>
                                    {paymentAmount >= 1000
                                      ? paymentAmount.toLocaleString("tr-TR", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      : paymentAmount.toFixed(2)}{" "}
                                    TL
                                  </div>
                                </div>
                              )}

                            {remainingAmount < 0 &&
                              paymentModule &&
                              isScoreRatioInsufficient && (
                                <div className="text-red small mt-3">
                                  {isFullScorePayment
                                    ? "Mevcut puanınız, sepetiniz için gereken minimum puanın altında."
                                    : "Ödemeye geçebilmek için mevcut puanınız, sepetiniz için gereken minimum puanın altında."}
                                  <br />
                                  (Gerekli puan:{" "}
                                  {Math.ceil(
                                    requiredMinimumScore
                                  ).toLocaleString("tr-TR")}
                                  , mevcut puanınız:{" "}
                                  {(profileDetail?.score || 0).toLocaleString(
                                    "tr-TR"
                                  )}
                                  )
                                </div>
                              )}

                            {!allConsentsAccepted && (
                              <div className="text-red small mt-3">
                                Sepetinizde onaylamanız gereken{" "}
                                {missingConsentCount} ürün bulunuyor. Ürünün
                                altındaki onay kutusunu işaretlemeden siparişi
                                tamamlayamazsınız.
                              </div>
                            )}

                            {remainingAmount < 0 &&
                              paymentModule &&
                              !isFullScorePayment && (
                                <button
                                  type="submit"
                                  disabled={
                                    isScoreRatioInsufficient || isSubmitting
                                  }
                                  className="btn btn-blue text-white rounded-pill py-sm-3 py-2 px-sm-4 px-3 mt-4 w-100"
                                >
                                  Ödemeye Geç
                                </button>
                              )}
                            {(remainingAmount >= 0 || isFullScorePayment) && (
                              <button
                                type="submit"
                                disabled={
                                  isSubmitting ||
                                  (isFullScorePayment &&
                                    isScoreRatioInsufficient)
                                }
                                className="btn btn-green text-white rounded-pill py-sm-3 py-2 px-sm-4 px-3 mt-4 w-100"
                              >
                                Siparişi Tamamla
                              </button>
                            )}
                            <button
                              type="button"
                              disabled={isSubmitting}
                              className="btn btn-red-danger text-white rounded-pill w-100 mt-2"
                              onClick={handleRemoveAllItems}
                            >
                              Tüm Ürünleri Kaldır
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </section>
        ) : (
          <section className="my-sm-10 my-5">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-7 col-md-10">
                  <div className="bg-gray-lightest rounded-3 p-5 text-center mb-5">
                    <h3 className="mb-5 text-red">🛒 Sepetiniz Boş!</h3>
                    <p className="lead mb-5">
                      Şu anda sepetinizde ürün bulunmamaktadır. Alışverişe devam
                      etmek için mağazamızı ziyaret edebilirsiniz.
                    </p>
                    <Link
                      to="/shop"
                      className="btn btn-blue text-white rounded-pill py-sm-3 py-2 px-sm-4 px-3"
                    >
                      Alışverişe Devam Et
                    </Link>
                  </div>
                  <p className="small fw-light opacity-75 text-center">
                    Siparişiniz ile ilgili sorularınız için Sıkça Sorulan
                    Sorular bölümünden yardım alabilir, Cargill Gurme Club Çağrı
                    Merkezi'ni 0850 335 1358 nolu telefondan Pazartesi ila Cuma
                    günleri 09:00-18:00 saatleri arasında arayabilir veya Bize
                    Ulaşın'dan bize erişebilirsiniz.
                  </p>
                </div>
              </div>
            </div>
          </section>
        )}
      </main>

      <Footer />
      <GlobalLoader isLoading={isLoading} />

      {/* Sözleşme Modalı (Ön Bilgilendirme Koşulları / Mesafeli Satış Sözleşmesi) */}
      <Modal
        show={!!agreementModal}
        onHide={() => setAgreementModal(null)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {agreementModal ? AGREEMENTS[agreementModal].title : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="agreement-content"
            style={{ maxHeight: "70vh", overflowY: "auto" }}
            dangerouslySetInnerHTML={{
              __html: agreementModal ? AGREEMENTS[agreementModal].html : "",
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setAgreementModal(null)}>
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Cart;
